import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function BrandLogo({ className = "h-9 sm:h-10 md:h-11", variant = "default" }) {
  const { content } = useLanguage();
  const useGlare = variant === "footer" || variant === "onDark";
  const imgClass = `${useGlare ? "logo-on-dark " : ""}w-auto object-contain ${className}`;

  return (
    <Link to="/" className="inline-flex shrink-0 items-center" data-testid="brand-logo-link">
      <img
        src={`${process.env.PUBLIC_URL}/logo.png`}
        alt={content.brand.name}
        className={imgClass}
        width={950}
        height={316}
        decoding="async"
      />
    </Link>
  );
}
